import React from "react";
import ConfigContainer from "./ConfigContainer/ConfigContainer";
import ContractDetails from "./ContractDetails/ContractDetails";

const PaymentMainDashboard = () => {
  return (
    <div
      style={{
        height: "calc(100% - 16px)",
        width: "calc(100% - 32px)",
        background: "#fff",
        padding: "8px",
        borderRadius: "4px",
      }}
      className="display_flex_column"
    >
      <ConfigContainer />
      <ContractDetails />
    </div>
  );
};

export default PaymentMainDashboard;
